<style>
  .novias {
    text-align: center;
    margin-top: 55px;
    padding: 0.5rem 1rem;
    max-width: 100vw;
  }
</style>

<template>
  <div class="novias">
    <ImageGallery class="image-gallery" :image-list="novias">
    </ImageGallery>
  </div>
</template>

<script>
import ImageGallery from '@/components/ImageGallery.vue'
import { novias } from '@/novias.js'

export default {
  name: 'novias',
  components: {
    ImageGallery
  },
  data () {
    return {
      novias: novias()
    }
  }
}
</script>
